import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import {
	AnyType,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'

@jsonClass('DeploymentAuthorization')
export class DeploymentAuthorization {
	@jsonProperty(String)
	get __type() {
		return 'DeploymentAuthorization'
	}
	set __type(_) {}
	@jsonProperty(Number)
	id?: number
	@jsonProperty(String)
	name?: string
	@jsonProperty(String)
	publicKeyPem!: string
	@jsonProperty(Boolean)
	allowWriting?: boolean
	@jsonProperty(AnyType)
	lastUsed: Record<string, string> = {} // <environmentId, isoTimestamp>

	constructor(init?: Partial<DeploymentAuthorization>) {
		assignCommonProperties(this, init)
	}
}
